import LoopIcon from '@mui/icons-material/Loop';
import { Button, Divider, Grid, Typography } from '@mui/material';
import { range, toString } from 'lodash';
import { ResourceSelectorWidget } from 'src/components/widget/resourceSelectorWidget/ResourceSelectorWidget';
import {
  QuillTheme,
  RichTextEditor,
  RichTextToolbarOptions,
} from 'src/components/widget/richTextWidget';
import { extractStylesFromHtml } from 'src/components/widget/richTextWidget/RichTextWidget.helpers';
import { lang } from 'src/utils';
import { getThumbnailSrc } from 'src/utils/gcf-helper';

import { PositionBox } from '../../../codThankyou/PositionBox';
import {
  type IMessageConfig,
  MessageConfigTypes,
} from '../../CODForm.interface';
import { RemoveMessageTitle } from '../../removeMessageTitle';
import { MessageListProps } from './MessageList.interface';

export const MessageList = ({
  messages,
  handleClickReplace,
  handleMessagesUpdate,
  deleteMessage,
  mappedFonts,
  errors,
  rteDefaultStyleValues,
}: MessageListProps) => {
  return messages.map((item: IMessageConfig, index: number) => ({
    titleComponent: (
      <RemoveMessageTitle
        label={`Set ${index + 1}`}
        onClick={() => deleteMessage(index)}
      />
    ),
    hasError: !!errors?.[index],
    content: (
      <Grid padding={3} container gap={1} direction="column">
        <Typography>
          {item.enabledTypeKey === MessageConfigTypes.IMAGE
            ? lang.image
            : lang.iconText}
        </Typography>
        <Divider />
        <Grid item xs={12}>
          <ResourceSelectorWidget
            value={getThumbnailSrc(
              item.enabledTypeKey === MessageConfigTypes.IMAGE
                ? item.image
                : item.iconAndText?.icon,
            )}
            onChange={() => {}}
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <Button
            component="label"
            variant="outlined"
            onClick={() => handleClickReplace(item.enabledTypeKey, index)}
            startIcon={<LoopIcon />}>
            {lang.replace}
          </Button>
        </Grid>
        {item.enabledTypeKey === MessageConfigTypes.ICON_AND_TEXT && (
          <RichTextEditor
            placeholder={lang.enterText}
            value={item.iconAndText?.label}
            onChange={(value) => {
              const htmlValue = toString(value);
              const extractedStyles = extractStylesFromHtml(htmlValue);

              // Save the HTML with formatting preserved
              handleMessagesUpdate(`${index}.iconAndText.label`)(htmlValue);

              // Extract and save font family separately
              if (extractedStyles.fontFamily) {
                handleMessagesUpdate(`${index}.iconAndText.font`)(
                  extractedStyles.fontFamily || item.iconAndText?.font,
                );
              }
            }}
            theme={QuillTheme.TOOLBAR}
            fontFamily={mappedFonts}
            fontSize={range(8, 100).map((size) => `${size}px`)}
            letterSpacing={['0px', '1px', '2px']}
            hide={[RichTextToolbarOptions.STRIKE]}
            defaultStyleValues={{
              fontFamily: rteDefaultStyleValues?.fontFamily,
            }}
          />
        )}
        <Grid
          container
          justifyContent="space-between"
          direction="row"
          wrap="nowrap"
          gap={1}>
          <PositionBox
            x={item.left || 0}
            y={item.top || 0}
            onChange={(left, top) =>
              handleMessagesUpdate(`${index}`)({ ...item, left, top })
            }
          />
        </Grid>
      </Grid>
    ),
  }));
};
